<template>
  <div class="ocr-test-file">
    <drop-uploader
      ref="dropUploader"
      :action="URL.sys.ocrImportAndAnalyseFile"
      :upload-params="{ ocrTemplateUuid: ocrTemplate.uuid }"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :close-on-click-modal="false"
      :multiple="false"
      @upload-result="uploadResult"
    />
    <cargo-left-right-resize
      style="width:100%;height: 80%;"
      :left-style="{'min-width': '550px',width:'50%'}"
      :right-style="{'min-width': '550px',width:'50%'}"
    >
      <template slot="left">
        <div>
          <span>{{ $t('CargoMsg.Cargo_FileName2') + (ocrTemplate.fileName || '') }}</span>
          <el-button type="primary" style="width: 110px;margin-left: 5px" no="uploadFile" @click="$refs.dropUploader.triggeFileSelectWindow()">{{ $t('SeaExport.UploadFile') }}</el-button>
        </div>
        <div style="width: 100%;height:95%;overflow: auto;border: 1px solid #cccccc;margin-top: 10px">
          <image-preview-cwmi v-if="resultArray && resultArray.length > 0" :image-info="resultArray[pageNum-1].pointer" :cur-focus="curFocus" />
        </div>
      </template>
      <template slot="right">
        <div style="height:26px;margin-top: 12px">
          <span>{{ $t('CargoMsg.Cargo_IdentifyReturnResult') }}</span>
        </div>
        <div style="border: 1px solid #cccccc;height: 95%">
          <div style="padding: 10px;height: 100%;overflow-y: auto;">
            <div v-if="ocrTemplate.resultJsonTableData && ocrTemplate.resultJsonTableData.length > 0 && ocrTemplate.resultJsonTableData[pageNum-1].length > 0" style="border: 1px solid black;height: auto">
              <div
                v-for="(pair, index) in ocrTemplate.resultJsonTableData[pageNum-1]"
                :key="index"
                class="list-style"
                style="width: 100%;display: flex"
              >
                <div
                  style="width: 50%;display: flex;"
                  @click="()=>{
                    curFocus = pair[0][0]
                    if(resultArray[pageNum-1].pointer) {
                      resultArray[pageNum-1].pointer.curFocus=pair[0][0]
                    }
                  }"
                >
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[0][0] }}</span></div>
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[0][1] }}</span></div>
                </div>
                <div
                  v-if="pair[1]"
                  style="width: 50%;display: flex;"
                  @click="()=>{
                    curFocus = pair[1][0]
                    if(resultArray[pageNum-1].pointer) {
                      resultArray[pageNum-1].pointer.curFocus=pair[1][0]
                    }
                  }"
                >
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[1][0] }}</span></div>
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[1][1] }}</span></div>
                </div>
                <div
                  v-else
                  style="width: 50%;display: flex;"
                >
                  <div style="width: 100%;display: flex;border: 1px solid black;padding: 5px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <div slot="footer" style="display: flex;justify-content: center">
      <div>
        <!--分页-->
        <el-pagination
          style="position: absolute;right: 200px"
          :current-page.sync="pageNum"
          :pager-count="5"
          :page-size="1"
          layout="prev, pager, next, jumper"
          :total="total"
        />
      </div>
      <div style="margin-top: 50px">
        <div style="display: inline-block">
          <el-button type="primary" no="2" @click="jump(OCR_CODE_HANDLE.code)"> {{ $t('CargoMsg.Cargo_ModifyCodeHandle') }} </el-button>
        </div>
        <div style="display: inline-block">
          <el-button type="primary" no="3" style="margin-left: 5px;" @click="jump(OCR_DETAIL.code)"> {{ $t('CargoMsg.Cargo_ModifyPromptWords') }} </el-button>
        </div>
        <div style="display: inline-block">
          <el-button type="primary" no="1" style="margin-left: 5px;" @click="goBack()"> {{ $t('CargoMsg.Cargo_Back') }} </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreviewCwmi from '@/views/cargo/v0/ToolAssistant/ocr/components/ImagePreviewCwmi'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import URL from '@/api/urlTranslator'
import { OCR_CODE_HANDLE, OCR_DETAIL, OCR_TEMPLATE_STATUS_VALID } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OcrTestFile',
  components: { ImagePreviewCwmi, CargoLeftRightResize, DropUploader },
  props: {
    ocrTemplate: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      OCR_CODE_HANDLE, OCR_DETAIL,
      URL,
      curFocus: '',
      fileFormat: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif',
      pageNum: 1 // 当前页
    }
  },
  computed: {
    resultArray() {
      return this.ocrTemplate.resultJson ? (Array.isArray(JSON.parse(this.ocrTemplate.resultJson)) ? JSON.parse(this.ocrTemplate.resultJson) : null) : null
    },
    total() { // 总页数
      return this.ocrTemplate.resultJson ? (Array.isArray(JSON.parse(this.ocrTemplate.resultJson)) ? JSON.parse(this.ocrTemplate.resultJson).length : 0) : 0
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    }
  },
  watch: {
    'ocrTemplate.resultJson': {
      immediate: true,
      async handler() {
        if (this.ocrTemplate.resultJson && Array.isArray(JSON.parse(this.ocrTemplate.resultJson))) {
          const resultJsonTableData = []
          for (const item of JSON.parse(this.ocrTemplate.resultJson)) {
            const objectArray = Object.entries(item.text.data)
            const formattedArray = []
            for (let i = 0; i < objectArray.length; i += 2) {
              formattedArray.push([objectArray[i], objectArray[i + 1]])
            }
            resultJsonTableData.push(formattedArray)
          }
          this.ocrTemplate.resultJsonTableData = resultJsonTableData
        }
      }
    }
  },
  methods: {
    handleClose() {
      console.log('result close')
      this.$emit('close')
    },
    goBack() {
      this.$emit('goBack')
    },
    uploadResult(res) {
      this.ocrTemplate.originResultJson = res.originResultJson
      this.ocrTemplate.resultJson = res.resultJson
      this.ocrTemplate.fileName = res.fileName
    },
    jump(path) {
      // 模板生效且被租户绑定时，不可【编辑】、不可【代码处理】
      if (OCR_TEMPLATE_STATUS_VALID.code === this.ocrTemplate.active && this.ocrTemplate.used) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TemplateUsed'))
        return
      }
      this.$emit('jump', path)
    }
  }
}
</script>

<style lang="scss">
.ocr-test-file {
  padding-top: 20px;
  padding-left: 20px;
  background-color: white;
}
</style>
